import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Tooltip as Tooltip$1, Typography } from '@mui/material';
import { a as theme } from './theme-f4aeefe2.js';
import { makeStyles } from 'tss-react/mui';
import { useRef, useState, useEffect } from 'react';
import '@mui/material/Skeleton';
import '@mui/material/Box';
import Typography$1 from '@mui/material/Typography';
import '@mui/material/Menu';
import '@mui/material/Divider';
import '@mui/material/Grid';
import '@mui/material/Container';
import '@mui/material/Collapse';
import '@mui/material/Slide';
import '@mui/material/Modal';
import '@mui/material/IconButton';
import '@mui/material/CircularProgress';
import '@mui/material/MenuItem';
import '@mui/material/styles';
import '@mui/material/CssBaseline';
import '@mui/material/Paper';
import '@mui/material/Avatar';

/**
 * Tooltip customizable. We can use translation slug that contains bold tag <b></b> and italic tag <i></i>. translation slug who have " " text doesn't display any tooltip.
 */
const Tooltip = ({ children, title, text, placement, display, PopperProps, open, scheme = 'dark', className, disableInteractive, elements, arrow = true, }) => {
    return (title === null || title === void 0 ? void 0 : title.trim()) || (text === null || text === void 0 ? void 0 : text.trim()) || !!elements ? (jsx(Tooltip$1, { PopperProps: PopperProps, open: open, placement: placement || 'top', className: className, classes: {
            tooltip: scheme === 'dark' ? 'dark' : '',
        }, disableInteractive: disableInteractive, title: jsxs(Fragment, { children: [elements && elements, title && (jsx(Typography, { align: "left", variant: "caption", component: "p", style: { marginBottom: text ? '4px' : '0' }, children: title })), text && (jsx(Typography, { component: "p", align: "left", variant: "subcaption", color: scheme === 'dark' ? theme.palette.common.white : theme.palette.darkScale[700], children: text }))] }), arrow: arrow, children: jsx("span", { style: { display: display || 'block' }, children: children }) })) : (jsx(Fragment, { children: children }));
};

const useTextEllipsisTooltipStyles = makeStyles()((_, { lineClamp }) => ({
    textEllipsisTooltip: {
        display: 'block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    multiLine: {
        display: '-webkit-box',
        WebkitLineClamp: lineClamp.toString(), // string format is required to avoid transformation into px
        WebkitBoxOrient: 'vertical', // TODO adapt code, this is deprecated...
        overflow: 'hidden',
        whiteSpace: 'break-spaces',
    },
}));

const DATA_TEST_ID = 'text-ellipsis-tooltip';
const TextEllipsisTooltip = ({ text, typographyProps, tooltipProps, multiLineCount = 1, className, }) => {
    var _a;
    const isMultiline = multiLineCount > 1;
    const { classes } = useTextEllipsisTooltipStyles({ lineClamp: multiLineCount });
    const typographyRef = useRef(null);
    const [tooltipDisplayed, setTooltipDisplayed] = useState(false);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!typographyRef.current)
            return;
        let isTextOverflowing;
        if (isMultiline)
            isTextOverflowing = ((_a = typographyRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = typographyRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight);
        else
            isTextOverflowing = ((_c = typographyRef.current) === null || _c === void 0 ? void 0 : _c.scrollWidth) > ((_d = typographyRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth);
        setTooltipDisplayed(isTextOverflowing);
    }, [isMultiline, text]);
    return (jsx(Tooltip, Object.assign({ "data-testid": DATA_TEST_ID, display: "inline", scheme: "dark" }, tooltipProps, { text: tooltipDisplayed ? ((_a = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.text) !== null && _a !== void 0 ? _a : text) : null, className: className, children: jsx(Typography$1, Object.assign({ ref: typographyRef, className: `${classes.textEllipsisTooltip} ${isMultiline ? classes.multiLine : ''}` }, typographyProps, { component: "span", children: text })) })));
};

export { DATA_TEST_ID as D, Tooltip as T, TextEllipsisTooltip as a };
//# sourceMappingURL=TextEllipsisTooltip-dd731448.js.map
